// src/Pages/Selections/Selections.jsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FaEye,
  FaEdit,
  FaTrash,
  FaSearch,
  FaTimes,
  FaPlus,
  FaFilter,
  FaUser
} from "react-icons/fa";
import { openModal } from "../../redux/features/modalSlice";
import { successToast, errorToast } from "../../Utils/toast";
import Pagination from "../../common/Pagination";
import SearchBar from "../../common/Search";
import { setSelectionsFilters } from "../../redux/features/filtersSlice";
import {
  useGetSelectionsQuery,
  useDeleteSelectionMutation,
  useChangeSelectionStatusMutation,
} from "../../redux/services/selectionsService/selections.Services";
import { FaTrophy } from "react-icons/fa";

import { useGetWaadDropdownQuery } from "../../redux/services/waadService/waad.Services";
import CommonBreadcrumb from "../../common/CommonBreadcrumb";
function Selections() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filters = useSelector((state) => state.filters.selections || {});
  
  const [typeFilter, setTypeFilter] = useState(filters.type || "");
  const [statusFilter, setStatusFilter] = useState(filters.status || "");
  const [waadFilter, setWaadFilter] = useState(filters.waad_id || "");

  const { data, isLoading, refetch } = useGetSelectionsQuery(filters);
  const { data: waadData } = useGetWaadDropdownQuery();
  const [deleteSelection] = useDeleteSelectionMutation();
  const [changeStatus] = useChangeSelectionStatusMutation();

  const selectionsData = data?.data || [];
  const pagination = data?.pagination || {};
  const totalPages = pagination?.totalPages || 0;
  const totalItems = pagination?.total || 0;
  const currentPage = pagination?.page || 1;

  const isActive = (status) => status === 1 || status === "1";

  const getTypeBadge = (type) => {
    if (type === "sports") {
      return <span className="badge bg-success">Sports</span>;
    }
    return <span className="badge bg-primary">Govt Job</span>;
  };

  const handlePageChange = (page) => {
    dispatch(setSelectionsFilters({ page }));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSearch = (value) => {
    dispatch(setSelectionsFilters({ search: value, page: 1 }));
  };

  const handleTypeFilter = (type) => {
    setTypeFilter(type);
    dispatch(setSelectionsFilters({ type, page: 1 }));
  };

  const handleStatusFilter = (status) => {
    setStatusFilter(status);
    dispatch(setSelectionsFilters({ status, page: 1 }));
  };

  const handleWaadFilter = (waad_id) => {
    setWaadFilter(waad_id);
    dispatch(setSelectionsFilters({ waad_id, page: 1 }));
  };

  const clearFilters = () => {
    setTypeFilter("");
    setStatusFilter("");
    setWaadFilter("");
    dispatch(
      setSelectionsFilters({
        search: "",
        type: "",
        status: "",
        waad_id: "",
        page: 1,
      })
    );
  };

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    dispatch(setSelectionsFilters({ limit: newLimit, page: 1 }));
  };

  const handleDelete = async (id, name) => {
    if (window.confirm(`Are you sure you want to delete "${name}"?`)) {
      try {
        await deleteSelection(id).unwrap();
        successToast("Success", "Deleted successfully");
        refetch();
      } catch (error) {
        errorToast("Error", error?.data?.message || "Failed to delete");
      }
    }
  };

  const handleStatusToggle = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === 1 ? 0 : 1;
      await changeStatus({ id, status: newStatus }).unwrap();
      successToast("Success", "Status updated successfully");
      refetch();
    } catch (error) {
      errorToast("Error", error?.data?.message || "Failed to update status");
    }
  };

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <h5 className="mt-3">Loading selections...</h5>
      </div>
    );
  }

  return (
    <div>
      {/* Header */}
      {/* <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              Selections {totalItems > 0 && (
                <span className="badge-custom bg-primary">{totalItems}</span>
              )}
            </h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item active">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">Selections</li>
            </ol>
          </nav>
        </div>
        <div className="page-title fw-semibold fs-18 mb-0">
          <button
            onClick={() => navigate("/add-selection")}
            className="btn btn-primary me-2"
          >
            <FaPlus className="me-1" /> Add Selection
          </button>
        </div>
      </div> */}
<CommonBreadcrumb
    title="Selections"
    titleIcon={<FaTrophy className="me-2 text-primary" />}
    count={totalItems}
    breadcrumbs={[
        { label: "Home", link: "/" },
        { label: "Selections" },
    ]}
    buttons={[
        {
            text: "Add Selection",
            icon: <FaPlus className="me-1" />,
            onClick: () => navigate("/add-selection"),
            className: "btn btn-primary",
        },
    ]}
/>
      {/* Filters */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3 align-items-center">
            <div className="col-md-3">
              <SearchBar
                search={filters.search}
                setSearch={handleSearch}
                placeholder="Search by name, waad..."
              />
            </div>
            <div className="col-md-2">
              <select
                className="form-select"
                value={typeFilter}
                onChange={(e) => handleTypeFilter(e.target.value)}
              >
                <option value="">All Types</option>
                <option value="sports">Sports</option>
                <option value="govt_job">Govt Job</option>
              </select>
            </div>
            <div className="col-md-2">
              <select
                className="form-select"
                value={waadFilter}
                onChange={(e) => handleWaadFilter(e.target.value)}
              >
                <option value="">All Waads</option>
                {waadData?.data?.map((waad) => (
                  <option key={waad.id} value={waad.id}>
                    {waad.waad_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <select
                className="form-select"
                value={statusFilter}
                onChange={(e) => handleStatusFilter(e.target.value)}
              >
                <option value="">All Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
            <div className="col-md-2">
              <select
                className="form-select"
                value={filters.limit || 10}
                onChange={handleLimitChange}
              >
                <option value={5}>5 per page</option>
                <option value={10}>10 per page</option>
                <option value={20}>20 per page</option>
                <option value={50}>50 per page</option>
              </select>
            </div>
            <div className="col-md-1 text-end">
              {(filters.search || filters.type || filters.status || filters.waad_id) && (
                <button className="btn btn-outline-secondary" onClick={clearFilters}>
                  <FaTimes />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="st-wrapper-card">
        {selectionsData.length === 0 ? (
          <div className="text-center py-5">
            <FaSearch className="text-muted" size={48} />
            <h5 className="mt-3">No Selections Found</h5>
            <p className="text-muted">
              Click "Add Selection" to create your first selection
            </p>
          </div>
        ) : (
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Image</th>
                  <th>Member Name</th>
                  <th>Type</th>
                  <th>Waad</th>
                  <th>Mobile</th>
                  <th>Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {selectionsData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * (filters.limit || 10) + index + 1}</td>
                    <td>
                      {item.image ? (
                        <img
                          src={item.image_url || `${process.env.REACT_APP_API_URL}/uploads/selections/${item.image}`}
                          alt={item.member_name}
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            background: "#e9ecef",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#6c757d",
                          }}
                        >
                          <FaUser />
                        </div>
                      )}
                    </td>
                    <td className="fw-semibold">{item.member_name}</td>
                    <td>{getTypeBadge(item.type)}</td>
                    <td>{item.waad_name || "-"}</td>
                    <td>{item.mobile}</td>
                    <td>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={isActive(item.status)}
                          onChange={() => handleStatusToggle(item.id, item.status)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </td>
                    <td className="text-center">
                      <button
                        className="st-action-btn st-view-btn me-1"
                        title="View"
                        onClick={() =>
                          dispatch(
                            openModal({
                              type: "view-selection",
                              title: "View Selection",
                              data: item,
                            })
                          )
                        }
                      >
                        <FaEye />
                      </button>
                      <button
                        className="st-action-btn st-edit-btn me-1"
                        title="Edit"
                        onClick={() => navigate(`/edit-selection/${item.id}`)}
                      >
                        <FaEdit />
                      </button>
                      <button
                        className="st-action-btn st-delete-btn"
                        title="Delete"
                        onClick={() => handleDelete(item.id, item.member_name)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {pagination.totalPages > 1 && (
          <div className="d-flex flex-wrap align-items-center justify-content-between mt-4">
            <div className="text-muted small mb-2 mb-md-0">
              Showing {((currentPage - 1) * (filters.limit || 10)) + 1} to{" "}
              {Math.min(currentPage * (filters.limit || 10), totalItems)} of{" "}
              {totalItems} entries
            </div>
            <Pagination
              page={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Selections;